import "core-js/modules/es6.function.name";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var Parameters;

(function (Parameters) {
  var CustomParameter =
  /*#__PURE__*/
  function () {
    /**
     * Custom parameter
     * @constructor
     * @param {string} name - Name of the parameter
     * @param {string} value - Value of the parameter
     */
    function CustomParameter(name, value) {
      _classCallCheck(this, CustomParameter);

      this.name = name;
      this.value = value;

      if (!name) {
        throw Error("Name of the custom parameter is not specified");
      }
    }

    _createClass(CustomParameter, [{
      key: "getParam",
      value: function getParam() {
        return this.name;
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        return this.value;
      }
    }]);

    return CustomParameter;
  }();

  Parameters.CustomParameter = CustomParameter;
})(Parameters || (Parameters = {}));